/* eslint-disable no-console */
/**
 * index.js
 *
 * Main project entry point. Import all the initial scaffolding files here.
 *
 */

// Project-wide JS
import 'babel-polyfill'; // required by React & es6 scripts to work on IE11
import onDOMReady from './utils/onDomReady';

import '../components/components';
import '../sections/sections';
import '../charts/index';
import '../forms/forms';
import './utils/kenticoPageBuilder';
import './utils/intercom';

onDOMReady(() => {
    if (document.querySelector('.styleguide-group-nav') || document.querySelector('.styleguide-footer')) {
        import('../styleguide/styleguide').then(() => {
            console.info('Loaded JS: ../styleguide/styleguide');
        });
    }
});
